import GlobalWindow from "../Models/Window";

export enum HapticType {
    Selection,
    FeedBack,
}

export enum FeedbackMessage {
    Warning = "Warning",
    Success = "Success",
    Error = "Error",
}

const triggerHaptics = (type: HapticType = HapticType.Selection, feedbackMessage?: FeedbackMessage) => {
    const globalWindow: GlobalWindow = window as GlobalWindow;
    if (globalWindow.webkit) {
        switch (type) {
            case HapticType.Selection:
                if (globalWindow.webkit.messageHandlers.selection) {
                    globalWindow.webkit.messageHandlers.selectionPrepare.postMessage({body: true});
                    globalWindow.webkit.messageHandlers.selection.postMessage({body: true});
                }
                break;
            case HapticType.FeedBack:
                if (globalWindow.webkit.messageHandlers.feedback && feedbackMessage) {
                    globalWindow.webkit.messageHandlers.feedbackPrepare.postMessage({body: true})
                    globalWindow.webkit.messageHandlers.feedback.postMessage({type: feedbackMessage})
                }
                break;
        }
    }
};

export default triggerHaptics;